import React from "react";
import styled from "styled-components";
import { Column, Text, Row } from "../theme/index";
import ReactMarkdown from "react-markdown";

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  margin: 0 auto;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin: 2em 0;
  @media (max-width: 1100px) {
    width: 100%;
    margin: 1em auto;
  }
`;

const Avatar = styled.img`
  width: 175px;
  height: 175px;
  border-radius: 100%;
  margin-right: 2em;
  @media (max-width: 1100px) {
  }
`;

const Div = styled.div`
  border: 1px solid #ffaf77;
  height: 0.5px;
  width: 20%;
  background-color: #ffaf77;
  margin: 0 auto;
  margin-bottom: 1.5em;
`;

export default function Instructor({ instructor }) {
  return (
    <Wrapper>
      <Text protitle>About the instructor</Text>
      <Div />
      <Row justifycontent="center" width="85%" margin="2em auto">
        <Avatar
          src={`https://media.graphcms.com/${instructor.avatar.handle}`}
        />
        <Column width="35%">
          <Text protitle lineheight="1.2em">
            {instructor.name}
          </Text>
          <Text instructortitle>{instructor.title}</Text>
          <ReactMarkdown source={instructor.bio} escapeHtml={false} />
        </Column>
      </Row>
    </Wrapper>
  );
}



// WEBPACK FOOTER //
// ./src/components/shared/Instructor.jsx